import { Popover } from "@material-ui/core";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { toAbsoluteUrl } from "../../../../../../Utils/_helpers";

const ManageSoundCreateMobileView = ({
  handleCreateTTS,
  handleUploadSoundsDialog,
}) => {
  const [openCreateSoundMenu, setopenCreateSoundMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const id = openCreateSoundMenu ? "manage-sound-popover" : undefined;

  const handleCreateSoundMenu = (event, isOpened) => {
    setAnchorEl(event.currentTarget);
    setopenCreateSoundMenu(isOpened);
  };

  const closeCreateSoundMenu = () => {
    setAnchorEl(null);
    setopenCreateSoundMenu(false);
  };

  const handleOnClickCreateTTS = () => {
    closeCreateSoundMenu();
    handleCreateTTS();
  };

  const handleOnClickUploadSound = () => {
    closeCreateSoundMenu();
    handleUploadSoundsDialog();
  };

  return (
    <>
      <div className="mr-4">
        <img
          onClick={(event) =>
            handleCreateSoundMenu(event, openCreateSoundMenu ? false : true)
          }
          src={`${toAbsoluteUrl(
            `/media/sr/icons/${
              openCreateSoundMenu ? "more-icon-dark" : "more-icon-inactive"
            }.svg`
          )}`}
          alt="inbound"
          style={{ width: "32px", height: "32px", cursor: "pointer" }}
        />
      </div>
      <Popover
        id={id}
        open={openCreateSoundMenu}
        anchorEl={anchorEl}
        onClose={closeCreateSoundMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            backgroundColor: "white",
            width: "170px",
            whiteSpace: "pre",
            padding: "10px 6px 10px 20px",
            borderRadius: "4px",
            boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.13)",
            border: "solid 1px #f3f3f3",
            overflow: "hidden",
          },
        }}>
        <div
          className="d-flex flex-column"
          style={{ fontSize: "13px", color: "#2d358a" }}>
          <span
            className="d-block pb-4 pt-2"
            onClick={() => handleOnClickCreateTTS()}>
            <FormattedMessage id="create-tts" defaultMessage="Create TTS" />
          </span>

          <span
            className="d-block pb-3"
            onClick={() => handleOnClickUploadSound()}>
            <FormattedMessage
              id="upload-sounds"
              defaultMessage="Upload Sound"
            />
          </span>
        </div>
      </Popover>
    </>
  );
};

export default ManageSoundCreateMobileView;
